import { CheckIcon } from "@chakra-ui/icons";

export const renderBoolean = (value: unknown): React.ReactNode | string => {
  return value ? (<CheckIcon></CheckIcon>) : "No";
};
